'use client'

import { useEffect, useRef } from 'react'

type IframeContainerProps = {
  iframeTag: string
}

export const IframeContainer = ({ iframeTag }: IframeContainerProps) => {
  const iframeRef = useRef<HTMLIFrameElement>(null)
  const scriptRef = useRef<HTMLScriptElement | null>(null)

  useEffect(() => {
    const parser = new DOMParser()
    const doc = parser.parseFromString(iframeTag, 'text/html')
    const iframe = doc.querySelector('iframe')

    if (iframe && iframeRef.current) {
      iframeRef.current.src = iframe.src
      iframeRef.current.id = iframe.id

      scriptRef.current = document.createElement('script')
      scriptRef.current.src =
        'https://product.plainer.co.jp/static/external/external.js'
      scriptRef.current.onload = () => {
        const win = window as typeof window & {
          callFunction?: (id: string, src: string) => void
        }
        if (typeof win.callFunction === 'function') {
          win.callFunction(iframe.id, iframe.src)
        }
      }
      document.body.appendChild(scriptRef.current)
    }

    return () => {
      if (scriptRef.current) {
        document.body.removeChild(scriptRef.current)
      }
    }
  }, [iframeTag])

  return (
    <div className="overflow-hidden h-full w-full">
      <iframe ref={iframeRef} className="h-full w-full border-none" />
    </div>
  )
}
